import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import "./App.css";
import SideNav from "./components/SideNav";
import TopNav from "./components/TopNav";
// Removed Loader import
import WaitingList from "./components/WaitingList";

function App() {
  const location = useLocation(); // Get the current route

  // Define routes where the SideNav should not appear
  const noSideNavRoutes = ["/", "/form-page"];

  return (
    <div className="App">
      {/* Conditionally render TopNav */}
      {!noSideNavRoutes.includes(location.pathname) && <TopNav />}
      <div className="flex relative z-50">
        {/* Conditionally render SideNav */}
        {!noSideNavRoutes.includes(location.pathname) && <SideNav />}
        <Routes>
          <Route path="/" element={<WaitingList />} />
          {/* Uncomment these routes if needed in the future */}
          {/* <Route path="/form-page" element={<NextLandingPage />} />
          <Route path="/calendar" element={<CalendarSmm />} />
          <Route path="/settings" element={<UserSettings />} />
          <Route path="/signup-pro" element={<SignupPro />} />
          <Route path="/signup-basic" element={<SignupBasic />} />
          <Route path="/signup-free" element={<SignupFree />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/smmcards" element={<SmmCards />} /> */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;